
export interface VideoCodecInfo {
  width?: number;
  height?: number;
  dataRate?: number;
  codecName?: string;
  profile?: string;
  level?: string;
}

export interface AudioCodecInfo {
  sampleRate?: number;
  dataRate?: number;
  channels?: number;
  codecName?: string;
  profile?: string;
}

export function getVideoCodecName(codecId: number): string {
  switch (codecId) {
    case 7:
      return 'H.264';
    case 12:
      return 'HEVC (H.265)';
    default:
      return `Unknown video codec (ID: ${codecId})`;
  }
}

export function getAudioCodecName(codecId: number): string {
  switch (codecId) {
    case 10:
      return 'AAC';
    case 7:
      return 'MP3';
    default:
      return `Unknown audio codec (ID: ${codecId})`;
  }
}